import React, { useState } from "react";
import { graphql } from "gatsby";
import ContentTile from "./contentTile";
import CircleArrow from "../../../images/circle-arrow-black.svg";
import ProjectsGrid from "./projectsGrid";
import { insertUrlParam, getUrlParams } from "../../../utils/utils";

export const fragments = graphql`
  fragment Page_ProjectsGrid on PrismicPageDataBodyProjectsGrid {
    primary {
      projects_grid_tags {
        text
      }
      projects_grid_initial_size
      projects_grid_load_size
      projects_grid_title {
        text
      }
    }
    items {
      projects_grid_card_image {
        url
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 496)
      }
      projects_grid_card_type
      projects_grid_card_subtext {
        text
      }
      projects_grid_card_title {
        text
      }
    }
  }
  fragment FocusArea_ProjectsGrid on PrismicFocusAreaDataBodyProjectsGrid {
    primary {
      projects_grid_tags {
        text
      }
      projects_grid_initial_size
      projects_grid_load_size
      projects_grid_title {
        text
      }
    }
    items {
      projects_grid_card_image {
        url
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 460)
      }
      projects_grid_card_type
      projects_grid_card_subtext {
        text
      }
      projects_grid_card_title {
        text
      }
    }
  }
  fragment Homepage_ProjectsGrid on PrismicHomepageDataBodyProjectsGrid {
    primary {
      projects_grid_tags {
        text
      }
      projects_grid_initial_size
      projects_grid_load_size
      projects_grid_title {
        text
      }
    }
    items {
      projects_grid_card_image {
        url
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 460)
      }
      projects_grid_card_type
      projects_grid_card_subtext {
        text
      }
      projects_grid_card_title {
        text
      }
    }
  }
  fragment Project_ProjectsGrid on PrismicProjectDataBodyProjectsGrid {
    primary {
      projects_grid_tags {
        text
      }
      projects_grid_initial_size
      projects_grid_load_size
      projects_grid_title {
        text
      }
    }
    items {
      projects_grid_card_image {
        url
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 460)
      }
      projects_grid_card_type
      projects_grid_card_subtext {
        text
      }
      projects_grid_card_title {
        text
      }
    }
  }
`;

function ProjectsForFocusArea({ data, allProjects }) {
  const projects = allProjects.edges;
  const initialSize =
    getUrlParams("loadSize") ||
    data?.primary?.projects_manual_initial_size ||
    data?.primary?.projects_grid_initial_size ||
    2;
  const loadSize =
    data?.primary?.projects_manual_load_size ||
    data?.primary?.projects_grid_load_size ||
    2;
  const title = data?.primary?.projects_grid_title?.text;

  const [sliceSize, setSliceSize] = useState(initialSize);

  const loadMoreHandler = async () => {
    setSliceSize(sliceSize + loadSize);
    insertUrlParam("loadSize", sliceSize + loadSize + "");
  };

  const indexes = [2, 5, 8, 11];
  let allTiles = [];
  projects.forEach((project, idx) => {
    const contentTile = data?.items[indexes.indexOf(idx)];
    if (contentTile?.projects_grid_card_title?.text)
      allTiles.push(
        <ContentTile tile={contentTile} entryAnimation={"FADE_LEFT"} />
      );
    allTiles.push(project.node);
  });
  const tiles = allTiles.slice(0, sliceSize);

  if (!projects.length) return null;

  return (
    <div>
      <div className="projects-grid projects-grid__load forPage">
        {title && <p className="projects-grid__name">{title}</p>}
        <ProjectsGrid tiles={tiles} />
        {sliceSize < allTiles.length && (
          <button className="load-more" onClick={loadMoreHandler}>
            load more
            <CircleArrow className="circle-arrow" />
          </button>
        )}
      </div>
    </div>
  );
}

export default ProjectsForFocusArea;
